import React from 'react';

import './Patient.avatar.scss';

export function PatientAvatar({ bio, handleClick, small, status }) {
    const echoClick = () => {
        if(!!handleClick){
            handleClick(bio);
        }
    }

    const renderStatusColor = () => {
        if(!status){
            return ''
        }
        if(status === 'enrolled'){
            return <div className="_status _enrolled"></div>
        } 
        else if(status === 'registered'){
            return <div className="_status _registered"></div>
        }
        else if(status === 'paused'){
            return <div className="_status _paused"></div>
        }
        else if(status === 'disenrolled'){
            return <div className="_status _disenrolled"></div>
        }
        else{
            return ''
        }
    }

    if (bio.photo) {
        return (
            <div className={`_avatar ${small ? 'small' : ''} ${status === 'disenrolled' ? 'disenrolled' : ''}`} onClick={echoClick}>
                <div className="photo" style={{ backgroundImage: `url(${bio.photo})` }}>
                </div>
                {renderStatusColor()}
            </div>
        )
    } else {
        return (
            <div className={`_avatar  ${small ? 'small' : ''} ${status === 'disenrolled' ? 'disenrolled' : ''}`} onClick={echoClick}>
                <div className="_empty">
                    <h2>{bio.firstname.substring(0, 1)}{bio.lastname.substring(0, 1)}</h2>
                </div>
                {renderStatusColor()}
            </div>
        )
    }
}